import { useState } from 'react';
import { Alert, Modal, Typography, Button, Spin } from 'antd';
import { TrophyOutlined, BarChartOutlined } from '@ant-design/icons';

import { PowerHourConfig } from '../../dto/reporting-models';
import PowerHourRace from './power-hour-race';
import { PowerHourTimer } from './power-hour-timer';
import { strings } from '../../lang';
import { getLocalTimeBasedOnHoursAndMins } from '../../utils/time-utils';
import PowerHourTitleRefresh from './powerhour-title-refresh';

const { Text } = Typography;

interface PowerHourBarType {
  powerHourConfig: PowerHourConfig;
  loading?: boolean;
}

const PowerHourBar = ({ powerHourConfig, loading = false }: PowerHourBarType) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const endTime = getLocalTimeBasedOnHoursAndMins(powerHourConfig.endTimeUtc);

  return (
    <>
      <div className="bp-top-microphone">
        <Alert
          banner
          type="success"
          icon={<TrophyOutlined />}
          message={
            loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 32 }}>
                <Spin />
              </div>
            ) : (
              <Text strong style={{ color: 'var(--color-black)' }}>
                {strings.powerHour.powerHourStarted}
              </Text>
            )
          }
          action={
            loading ? null : (
              <div className="ml-2 flex items-center gap-3">
                <PowerHourTimer endTime={endTime} isPowerHourBar />
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  onClick={() => setModalOpen(true)}
                  className="flex items-center"
                  style={{
                    backgroundColor: 'var(--status-success-text)',
                    borderColor: 'var(--status-success-text)',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '14px',
                    padding: '4px 12px',
                    boxShadow: 'none',
                    marginLeft: '22px',
                  }}
                >
                  {strings.powerHour.liveResults}
                </Button>
              </div>
            )
          }
          style={{
            backgroundColor: 'var(--power-hour-banner-bg)',
            padding: '12px 36px',
            flex: 1,
          }}
        />
      </div>
      <Modal open={modalOpen} onCancel={() => setModalOpen(false)} footer={null} width={800} title={<PowerHourTitleRefresh isLoading={isLoading} setRefreshKey={setRefreshKey} />}>
        <PowerHourRace setIsLoading={setIsLoading} powerHourConfig={powerHourConfig} refreshKey={refreshKey} />
      </Modal>
    </>
  );
};
export default PowerHourBar;
